import React, { useEffect, useState } from 'react';
import Layout from '../components/navbar/Layout';
import TabComponent from '../components/TabComponent'; // TabComponent 경로를 수정해주세요
import StuffTab1 from '../components/stuff/StuffTab1';
import StuffTab2 from '../components/stuff/StuffTab2';
import StuffTab3 from '../components/stuff/StuffTab3';
import StuffTab4 from '../components/stuff/StuffTab4';
import UnauthorizedMessage from '../components/UnauthorizedMessage';
import { useLocation, useNavigate } from 'react-router-dom';
import { StuffPageUrl } from '../url/poenUrl';
import LoginRedirect from '../components/LoginRedirect';

function StuffPage() {
  const [isSeller, setIsSeller] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // 탭 데이터 정의
  const tabs = [
    { title: '매물 리스트', content: <StuffTab1 /> },
    { title: '진단 보고서', content: <StuffTab2 /> },
    { title: '진단 데이터', content: <StuffTab3 /> },
    { title: '판매자 정보', content: <StuffTab4 /> },
  ];

  // 권한 확인
  useEffect(() => {
    const storedPermissions = localStorage.getItem('permissions');
    if (storedPermissions === 'SELLER') {
      setIsSeller(true);
    }
  }, []);

  // activeTab 값이 URL 쿼리에서 읽어와서 해당 탭을 활성화
  const activeTabFromUrl = new URLSearchParams(location.search).get(
    'activeTab'
  );
  const initialTab = activeTabFromUrl ? parseInt(activeTabFromUrl, 10) : 0;

  const handleTabChange = (index: number) => {
    // activeTab에 따라 URL을 다르게 설정

    navigate(`${StuffPageUrl}?activeTab=${index}`);
  };

  return (
    <Layout>
      <LoginRedirect />
      {isSeller ? (
        <UnauthorizedMessage />
      ) : (
        <TabComponent
          tabs={tabs}
          activeTab={initialTab}
          onTabChange={handleTabChange} // 탭 변경 시 호출되는 함수
        />
      )}
    </Layout>
  );
}

export default StuffPage;
